import { cn } from '@/lib/cn';
import { RANGE_KEYS, RANGE_LABELS, type RangeKey } from '@/lib/range';
import { useRange } from '@/lib/useRange';

export function RangePicker(): JSX.Element {
  const [current, setRange] = useRange();
  return (
    <div
      role="tablist"
      aria-label="Time range"
      className="inline-flex rounded-lg border border-surface-divider bg-surface-raised p-1"
    >
      {RANGE_KEYS.map((k) => (
        <Pill
          key={k}
          active={k === current}
          onClick={() => setRange(k)}
          label={RANGE_LABELS[k]}
        />
      ))}
    </div>
  );
}

function Pill({
  active,
  onClick,
  label,
}: {
  active: boolean;
  onClick: () => void;
  label: string;
}): JSX.Element {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={cn(
        'rounded-md px-3 py-1 text-xs font-bold uppercase tracking-wide transition-colors',
        active
          ? 'bg-brand-red text-fg'
          : 'text-fg-subtle hover:text-fg hover:bg-surface-bg/40',
      )}
    >
      {label}
    </button>
  );
}

// Wrap labels with a hint that explains what the range affects.
export function RangeForCharts(): RangeKey {
  return useRange()[0];
}
